// extracted by mini-css-extract-plugin
export default {"footerCon":"Footer_footerCon__mCGOk","listCon":"Footer_listCon__aG5aW","socialCon":"Footer_socialCon__RRVL0"};